











































































































































import { Vue, Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { db, busy, toaster, auth, VIPIp, VIPIpRest, IVIPIp, VIPIpEquivalenceRest, VipIpStatus, DBType } from "@/loader";
import EntityEdit from "@/component/EntityEdit";
import IpSelect from "../../component/ip/IpSelect.vue";
import { VIPIpEditComponentMixin } from '@/mixins/VIPIpMixin';

@Component({
	components: {
		IpSelect,
	}
})
export default class IpEdit extends Mixins(VIPIpEditComponentMixin) {
	public get ips(): VIPIp[] {
		return db.ips.list
			.filter(i => i.id !== this.item.id)
			.sort((a, b) => a.code.toString().localeCompare(b.code.toString()))
	}

	public get equivalences(): number[] {
		return this.item.give.map(ipe => ipe.fk_ip);
	}

	public set equivalences(ids: number[]) {
		ids.forEach(id => {
			if (!this.item.give.find(ipe => ipe.fk_ip === id)) {
				db.ipEquivalences.insert({
					fk_ip_parent: this.item.id,
					fk_ip: id,
				});
			}
		});
		this.item.give.forEach(ipe => {
			if (!ids.includes(ipe.fk_ip)) {
				db.ipEquivalences.remove(ipe);
			}
		});
		this.changed = true;
	}

	public save() {
		if (!this.canEdit || !this.item) {
			return;
		}
		if (!this.check()) {
			toaster.toast({ message: "Certaines informations ne sont pas valides.", variant: "warning", noAutoHide: false });
			return;
		}

		busy.start(`Sauvegarde de l'IP ${this.item.code} ...`);
		let equiv = this.item.give.map(ipe => ipe.fk_ip);
		let p = this.item.id < 0 ? VIPIpRest.create(this.item) : VIPIpRest.update(this.item);
		p.then(result => {
			if (result.success && result.item) {
				return VIPIpEquivalenceRest.batch(result.item.id, equiv);
			}
			return result;
		}).then(result => {
			if (result.success) {
				toaster.toast({
					message: `L'IP ${this.item.code} a été enregistrée.`,
					variant: "success",
				});
				this.changed = false;
				this.unfocusAll();
				this.$emit("saved", this.item);
			}
		}).finally(() => {
			busy.stop();
		});
	}

	public unmount() {
		if (this.changed) {
			if (this.item.id < 0) {
				this.remove();
			} else {
				VIPCompanyRest.get(this.item);
			}
		}
	}

	@Watch("item")
	public itemChanged(newValue?: VIPIp, oldValue?: VIPIp) {
		if (newValue !== oldValue) {
			this.changed = false;
			this.unfocusAll();
		}
	}
}
